import { gql } from '@apollo/client';

export const QUERY_PICKUP_DASHBOARD = gql`
  query QueryPickupDashboard($input: PickupDashboardQueryInput!) {
    queryPickupDashboard(input: $input) {
      latestCalculatedAt
      items {
        bizDate
        hubId
        customerId
        successCollectReservation
        shouldCollectReservation
        onlinePackageQty
        ascanOnlinePackageQty
        orderPackageQty
        packageOnlineDuration
        expectedTimeOnlineQty2
        expectedTimePackageQty
        newAddressCount
        cleanedNewAddressCount
        newWarehouseConnectCount
        failWarehouseVisitCount
        newAddressProcessCount
        reservationCount
        dueReservationCount
        confirmReservationCount
        longDueCount
        longConfirmCount
        manualDueCount
        manualConfirmCount
        sysDueCount
        sysConfirmCount
        sysExpectedTimeDueCount
        sysExpectedTimeConfirmCount
        sysNewDueCount
        sysNewConfirmCount
        sysOtherDueCount
        sysOtherConfirmCount
        sysNslaDueCount
        sysNslaConfirmCount
        sysSlaDueCount
        sysSlaConfirmCount
        temuDueCount
        temuConfirmCount
        wiringReservationCount
        longWiringCount
        manualWiringCount
        sysWiringCount
        sysExpectedWiringCount
        expectedWiringCount
        sysNewWiringCount
        sysOtherWiringCount
        sysNslaWiringCount
        sysSlaWiringCount
        temuWiringCount
        visitReservationCount
        successVisitCount
        longVisitCount
        expectedVisitCount
      }
    }
  }
`;
